/* eslint-disable import/no-unresolved */
/**
 * HIDA Fachportal frontend
 *
 * @author ressourcenmangel an der Panke GmbH <adp@ressourcenmangel.de>
 */

// Must run before any dynamic import() so lazy chunks resolve against the
// real dist root instead of webpack.config.js's static publicPath.
import './shims/public-path';

// Shims
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'url-polyfill';
import 'mdn-polyfills/Node.prototype.append';
import 'mdn-polyfills/Node.prototype.remove';
import 'mdn-polyfills/CustomEvent';
import 'mdn-polyfills/NodeList.prototype.forEach';
import 'mdn-polyfills/String.prototype.includes';
import 'mdn-polyfills/Element.prototype.matches';
import 'mdn-polyfills/Element.prototype.closest';
import 'focus-visible';
import './shims/focus-within';

// Shared
import './globals/print';
import './globals/popup';

// Components
import 'components/atoms/icon-button/icon-button';
import 'components/atoms/parallax/parallax';
import 'components/atoms/tom-select/tom-select';
import 'components/molecules/gallery/gallery';
import 'components/molecules/filter/filter';
import 'components/molecules/share/share';
import 'components/molecules/slider/slider';
import 'components/molecules/tabs/tabs';
import 'components/organisms/cookie-layer/cookie-layer';
import 'components/organisms/header/header';
import 'components/organisms/news/news';
import 'components/organisms/quickinfo/quickinfo';
import 'components/organisms/stage-video/stage-video';
import 'components/organisms/section-video/section-video';
import 'components/organisms/search/search';

// The chatbot is the one component heavy enough to split: it drags in
// markdown-it (~34 KB gzipped), and only a handful of pages have a chatbot.
// main.js is footer-loaded, so the DOM is parsed and this guard is
// equivalent to the querySelectorAll bootstrap inside the module — pages
// without a chatbot never request the chunk at all. The module
// self-initializes at import time, so the import IS the boot.
if (document.querySelector('.chatbot')) {
  import(/* webpackChunkName: "chatbot" */ 'components/organisms/chatbot/chatbot');
}
